<template>
  <div id="beambox-embeddable-form" v-bind:style="cssProps">
    <div v-bind:class="(mode == 'Popup')?'beambox-mask':''">
      <div v-bind:class="(mode == 'Popup')?'beambox-main-cont':'beambox-main-cont-inline'">

        <div id="beambox-complete">
          <div class="checkmark">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"/></svg>
          </div>
          <div>
            <p>You are subscribed!</p>
          </div>
        </div>

        <button id="beambox-close-form" type="button" name="button" v-on:click="close" v-if="mode == 'Popup'">X</button>
        <div v-bind:style="(show_image)?'display:block':'display:none'" v-bind:class="(mode == 'Popup')?'beambox-img-cont':'beambox-img-cont-inline'" v-if="mode == 'Popup'">
          <img v-bind:src="image_url" class="beambox-padding2t beambox-text-center beambox-logo" >
        </div>
        <div class="beambox-main-description" v-html="title_text"></div>
        <form @submit.prevent="submit" ref="form" id="beambox-signup-form">
          <input type="hidden" name="guest[sub_provider]" v-model="subProvider" value="" />
          <div v-for="(item, index) in form_fields">

            <div class="beambox-form-item" v-bind:class="(index == 0)?'beambox-active':''" v-on:click="select" v-bind:id="item.id">
              <label v-bind:for="item.id">{{item.label}}</label>
              <input required type="text" v-model="full_name" name="guest[full_name]" value="" v-if="item.id == 'full_name'">
              <input required type="text" v-model="first_name" name="guest[first_name]" value="" v-else-if="item.id == 'first_name'">
              <input required type="text" v-model="last_name" name="guest[last_name]" value="" v-else-if="item.id == 'last_name'">
              <input required type="email" v-model="email" name="guest[email]" value="" v-else-if="item.id == 'email'" >
              <div class="beambox-row" id="beambox-gender-picker"  v-else-if="item.id == 'gender'">
                <div class="beambox-small-12 beambox-select">
                  <select required class="" v-model="gender" name="guest[gender]">
                    <option></option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
              <div class="beambox-row " id="beambox-phone-picker" v-else-if="item.id == 'phone_number'">
                <div class="beambox-small-3 beambox-select">
                  <select required class="" name="code" id="phone_code" v-model="countryCode" v-on:change="updatePhone">
                    <option></option>
                    <option value="+93">+93</option>
                    <option value="+355">+355</option>
                    <option value="+213">+213</option>
                    <option value="+1-684">+1-684</option>
                    <option value='+376'>+376</option>
                    <option value='+244'>+244</option>
                    <option value='+1-264'>+1-264</option>
                    <option value='+672'>+672</option>
                    <option value='+1-268'>+1-268</option>
                    <option value='+54'>+54</option>
                    <option value='+374'>+374</option>
                    <option value='+297'>+297</option>
                    <option value='+61'>+61</option>
                    <option value='+43'>+43</option>
                    <option value='+1-242'>+1-242</option>
                    <option value='+994'>+994</option>
                    <option value='+973'>+973</option>
                    <option value='+880'>+880</option>
                    <option value='+1-246'>+1-246</option>
                    <option value='+375'>+375</option>
                    <option value='+32'>+32</option>
                    <option value='+501'>+501</option>
                    <option value='+229'>+229</option>
                    <option value='+1-441'>+1-441</option>
                    <option value='+975'>+975</option>
                    <option value='+591'>+591</option>
                    <option value='+387'>+387</option>
                    <option value='+267'>+267</option>
                    <option value='+47'>+47</option>
                    <option value='+55'>+55</option>
                    <option value='+246'>+246</option>
                    <option value='+1-284'>+1-284</option>
                    <option value='+673'>+673</option>
                    <option value='+359'>+359</option>
                    <option value='+226'>+226</option>
                    <option value='+257'>+257</option>
                    <option value='+855'>+855</option>
                    <option value='+237'>+237</option>
                    <option value='+1'>+1</option>
                    <option value='+238'>+238</option>
                    <option value='+599'>+599</option>
                    <option value='+1-345'>+1-345</option>
                    <option value='+236'>+236</option>
                    <option value='+235'>+235</option>
                    <option value='+56'>+56</option>
                    <option value='+86'>+86</option>
                    <option value='+61'>+61</option>
                    <option value='+61'>+61</option>
                    <option value='+57'>+57</option>
                    <option value='+269'>+269</option>
                    <option value='+242'>+242</option>
                    <option value='+243'>+243</option>
                    <option value='+682'>+682</option>
                    <option value='+506'>+506</option>
                    <option value='+385'>+385</option>
                    <option value='+53'>+53</option>
                    <option value='+599'>+599</option>
                    <option value='+357'>+357</option>
                    <option value='+420'>+420</option>
                    <option value='+225'>+225</option>
                    <option value='+45'>+45</option>
                    <option value='+253'>+253</option>
                    <option value='+1-767'>+1-767</option>
                    <option value='+1-809,1-829,1-849'>+1-809,1-829,1-849</option>
                    <option value='+593'>+593</option>
                    <option value='+20'>+20</option>
                    <option value='+503'>+503</option>
                    <option value='+240'>+240</option>
                    <option value='+291'>+291</option>
                    <option value='+372'>+372</option>
                    <option value='+251'>+251</option>
                    <option value='+500'>+500</option>
                    <option value='+298'>+298</option>
                    <option value='+679'>+679</option>
                    <option value='+358'>+358</option>
                    <option value='+33'>+33</option>
                    <option value='+594'>+594</option>
                    <option value='+689'>+689</option>
                    <option value='+262'>+262</option>
                    <option value='+241'>+241</option>
                    <option value='+220'>+220</option>
                    <option value='+995'>+995</option>
                    <option value='+49'>+49</option>
                    <option value='+233'>+233</option>
                    <option value='+350'>+350</option>
                    <option value='+30'>+30</option>
                    <option value='+299'>+299</option>
                    <option value='+1-473'>+1-473</option>
                    <option value='+590'>+590</option>
                    <option value='+1-671'>+1-671</option>
                    <option value='+502'>+502</option>
                    <option value='+44'>+44</option>
                    <option value='+224'>+224</option>
                    <option value='+245'>+245</option>
                    <option value='+592'>+592</option>
                    <option value='+509'>+509</option>
                    <option value='+672'>+672</option>
                    <option value='+504'>+504</option>
                    <option value='+852'>+852</option>
                    <option value='+36'>+36</option>
                    <option value='+354'>+354</option>
                    <option value='+91'>+91</option>
                    <option value='+62'>+62</option>
                    <option value='+98'>+98</option>
                    <option value='+964'>+964</option> <option value='+353'>+353</option> <option value='+44'>+44</option> <option value='+972'>+972</option> <option value='+39'>+39</option> <option value='+1-876'>+1-876</option> <option value='+81'>+81</option> <option value='+44'>+44</option> <option value='+962'>+962</option> <option value='+7'>+7</option> <option value='+254'>+254</option> <option value='+686'>+686</option> <option value='+965'>+965</option> <option value='+996'>+996</option> <option value='+856'>+856</option> <option value='+371'>+371</option> <option value='+961'>+961</option> <option value='+266'>+266</option> <option value='+231'>+231</option> <option value='+218'>+218</option> <option value='+423'>+423</option> <option value='+370'>+370</option> <option value='+352'>+352</option> <option value='+853'>+853</option> <option value='+389'>+389</option> <option value='+261'>+261</option> <option value='+265'>+265</option> <option value='+60'>+60</option> <option value='+960'>+960</option> <option value='+223'>+223</option> <option value='+356'>+356</option> <option value='+692'>+692</option> <option value='+596'>+596</option> <option value='+222'>+222</option> <option value='+230'>+230</option> <option value='+262'>+262</option> <option value='+52'>+52</option> <option value='+691'>+691</option> <option value='+373'>+373</option> <option value='+377'>+377</option> <option value='+976'>+976</option> <option value='+382'>+382</option> <option value='+1-664'>+1-664</option> <option value='+212'>+212</option> <option value='+258'>+258</option> <option value='+95'>+95</option> <option value='+264'>+264</option> <option value='+674'>+674</option> <option value='+977'>+977</option> <option value='+31'>+31</option> <option value='+687'>+687</option> <option value='+64'>+64</option> <option value='+505'>+505</option> <option value='+227'>+227</option> <option value='+234'>+234</option> <option value='+683'>+683</option> <option value='+672'>+672</option> <option value='+850'>+850</option> <option value='+1-670'>+1-670</option> <option value='+47'>+47</option> <option value='+968'>+968</option> <option value='+92'>+92</option> <option value='+680'>+680</option> <option value='+970'>+970</option> <option value='+507'>+507</option> <option value='+675'>+675</option> <option value='+595'>+595</option> <option value='+51'>+51</option> <option value='+63'>+63</option> <option value='+870'>+870</option> <option value='+48'>+48</option> <option value='+351'>+351</option> <option value='+1'>+1</option> <option value='+974'>+974</option> <option value='+40'>+40</option> <option value='+7'>+7</option> <option value='+250'>+250</option> <option value='+262'>+262</option> <option value='+685'>+685</option> <option value='+378'>+378</option> <option value='+966'>+966</option> <option value='+221'>+221</option> <option value='+381 p'>+381 p</option> <option value='+248'>+248</option> <option value='+232'>+232</option> <option value='+65'>+65</option> <option value='+1-721'>+1-721</option> <option value='+421'>+421</option> <option value='+386'>+386</option> <option value='+677'>+677</option> <option value='+252'>+252</option> <option value='+27'>+27</option> <option value='+500'>+500</option> <option value='+82'>+82</option> <option value='+211'>+211</option> <option value='+34'>+34</option> <option value='+94'>+94</option> <option value='+590'>+590</option> <option value='+290 n'>+290 n</option> <option value='+1-869'>+1-869</option> <option value='+1-758'>+1-758</option> <option value='+590'>+590</option> <option value='+508'>+508</option> <option value='+1-784'>+1-784</option> <option value='+249'>+249</option> <option value='+597'>+597</option> <option value='+47'>+47</option> <option value='+268'>+268</option> <option value='+46'>+46</option> <option value='+41'>+41</option> <option value='+963'>+963</option> <option value='+239'>+239</option> <option value='+886'>+886</option> <option value='+992'>+992</option> <option value='+255'>+255</option> <option value='+66'>+66</option> <option value='+670'>+670</option> <option value='+228'>+228</option> <option value='+690'>+690</option> <option value='+676'>+676</option> <option value='+1-868'>+1-868</option> <option value='+216'>+216</option> <option value='+90'>+90</option> <option value='+993'>+993</option> <option value='+1-649'>+1-649</option> <option value='+688'>+688</option> <option value='+1-340'>+1-340</option> <option value='+44'>+44</option> <option value='+1'>+1</option> <option value='+256'>+256</option> <option value='+380'>+380</option> <option value='+971'>+971</option> <option value='+598'>+598</option> <option value='+998'>+998</option> <option value='+678'>+678</option> <option value='+39-06'>+39-06</option> <option value='+58'>+58</option> <option value='+84'>+84</option> <option value='+681'>+681</option> <option value='+212'>+212</option> <option value='+967'>+967</option> <option value='+260'>+260</option> <option value='+263'>+263</option>
                  </select>
                </div>
                <div class="beambox-small-9 beambox-text">
                  <input required type="text" name="number" value="" id="phone_number_val" v-on:keyup="updatePhone">
                </div>
                <input required type="hidden" v-model="phone" name="guest[phone]" value="" id="guest_phone">
              </div>

              <div class="beambox-row " id="beambox-country-picker" v-else-if="item.id == 'country'">
                <div class="beambox-small-12 beambox-select">
                  <select required class="" v-model="country" name="guest[country]">
                    <option value='Afghanistan'>Afghanistan</option> <option value='Åland Islands'>Åland Islands</option> <option value='Albania'>Albania</option> <option value='Algeria'>Algeria</option> <option value='American Samoa'>American Samoa</option> <option value='Andorra'>Andorra</option> <option value='Angola'>Angola</option> <option value='Anguilla'>Anguilla</option> <option value='Antarctica'>Antarctica</option> <option value='Antigua and Barbuda'>Antigua and Barbuda</option> <option value='Argentina'>Argentina</option> <option value='Armenia'>Armenia</option> <option value='Aruba'>Aruba</option> <option value='Australia'>Australia</option> <option value='Austria'>Austria</option> <option value='Azerbaijan'>Azerbaijan</option> <option value='Bahamas'>Bahamas</option> <option value='Bahrain'>Bahrain</option> <option value='Bangladesh'>Bangladesh</option> <option value='Barbados'>Barbados</option> <option value='Belarus'>Belarus</option> <option value='Belgium'>Belgium</option> <option value='Belize'>Belize</option> <option value='Benin'>Benin</option> <option value='Bermuda'>Bermuda</option> <option value='Bhutan'>Bhutan</option> <option value='Bolivia'>Bolivia</option> <option value='Bosnia and Herzegovina'>Bosnia and Herzegovina</option> <option value='Botswana'>Botswana</option> <option value='Bouvet Island'>Bouvet Island</option> <option value='Brazil'>Brazil</option> <option value='British Indian Ocean Territory'>British Indian Ocean Territory</option> <option value='Brunei Darussalam'>Brunei Darussalam</option> <option value='Bulgaria'>Bulgaria</option> <option value='Burkina Faso'>Burkina Faso</option> <option value='Burundi'>Burundi</option> <option value='Cambodia'>Cambodia</option> <option value='Cameroon'>Cameroon</option> <option value='Canada'>Canada</option> <option value='Cape Verde'>Cape Verde</option> <option value='Cayman Islands'>Cayman Islands</option> <option value='Central African Republic'>Central African Republic</option> <option value='Chad'>Chad</option> <option value='Chile'>Chile</option> <option value='China'>China</option> <option value='Christmas Island'>Christmas Island</option> <option value='Cocos (Keeling) Islands'>Cocos (Keeling) Islands</option> <option value='Colombia'>Colombia</option> <option value='Comoros'>Comoros</option> <option value='Congo'>Congo</option> <option value='Congo, The Democratic Republic of The'>Congo, The Democratic Republic of The</option> <option value='Cook Islands'>Cook Islands</option> <option value='Costa Rica'>Costa Rica</option> <option value='Cote D'ivoire'>Cote D'ivoire</option> <option value='Croatia'>Croatia</option> <option value='Cuba'>Cuba</option> <option value='Cyprus'>Cyprus</option> <option value='Czech Republic'>Czech Republic</option> <option value='Denmark'>Denmark</option> <option value='Djibouti'>Djibouti</option> <option value='Dominica'>Dominica</option> <option value='Dominican Republic'>Dominican Republic</option> <option value='Ecuador'>Ecuador</option> <option value='Egypt'>Egypt</option> <option value='El Salvador'>El Salvador</option> <option value='Equatorial Guinea'>Equatorial Guinea</option> <option value='Eritrea'>Eritrea</option> <option value='Estonia'>Estonia</option> <option value='Ethiopia'>Ethiopia</option> <option value='Falkland Islands (Malvinas)'>Falkland Islands (Malvinas)</option> <option value='Faroe Islands'>Faroe Islands</option> <option value='Fiji'>Fiji</option> <option value='Finland'>Finland</option> <option value='France'>France</option> <option value='French Guiana'>French Guiana</option> <option value='French Polynesia'>French Polynesia</option> <option value='French Southern Territories'>French Southern Territories</option> <option value='Gabon'>Gabon</option> <option value='Gambia'>Gambia</option> <option value='Georgia'>Georgia</option> <option value='Germany'>Germany</option> <option value='Ghana'>Ghana</option> <option value='Gibraltar'>Gibraltar</option> <option value='Greece'>Greece</option> <option value='Greenland'>Greenland</option> <option value='Grenada'>Grenada</option> <option value='Guadeloupe'>Guadeloupe</option> <option value='Guam'>Guam</option> <option value='Guatemala'>Guatemala</option> <option value='Guernsey'>Guernsey</option> <option value='Guinea'>Guinea</option> <option value='Guinea-bissau'>Guinea-bissau</option> <option value='Guyana'>Guyana</option> <option value='Haiti'>Haiti</option> <option value='Heard Island and Mcdonald Islands'>Heard Island and Mcdonald Islands</option> <option value='Holy See (Vatican City State)'>Holy See (Vatican City State)</option> <option value='Honduras'>Honduras</option> <option value='Hong Kong'>Hong Kong</option> <option value='Hungary'>Hungary</option> <option value='Iceland'>Iceland</option> <option value='India'>India</option> <option value='Indonesia'>Indonesia</option> <option value='Iran, Islamic Republic of'>Iran, Islamic Republic of</option> <option value='Iraq'>Iraq</option> <option value='Ireland'>Ireland</option> <option value='Isle of Man'>Isle of Man</option> <option value='Israel'>Israel</option> <option value='Italy'>Italy</option> <option value='Jamaica'>Jamaica</option> <option value='Japan'>Japan</option> <option value='Jersey'>Jersey</option> <option value='Jordan'>Jordan</option> <option value='Kazakhstan'>Kazakhstan</option> <option value='Kenya'>Kenya</option> <option value='Kiribati'>Kiribati</option> <option value='Korea, Democratic People's Republic of'>Korea, Democratic People's Republic of</option> <option value='Korea, Republic of'>Korea, Republic of</option> <option value='Kuwait'>Kuwait</option> <option value='Kyrgyzstan'>Kyrgyzstan</option> <option value='Lao People's Democratic Republic'>Lao People's Democratic Republic</option> <option value='Latvia'>Latvia</option> <option value='Lebanon'>Lebanon</option> <option value='Lesotho'>Lesotho</option> <option value='Liberia'>Liberia</option> <option value='Libyan Arab Jamahiriya'>Libyan Arab Jamahiriya</option> <option value='Liechtenstein'>Liechtenstein</option> <option value='Lithuania'>Lithuania</option> <option value='Luxembourg'>Luxembourg</option> <option value='Macao'>Macao</option> <option value='Macedonia, The Former Yugoslav Republic of'>Macedonia, The Former Yugoslav Republic of</option> <option value='Madagascar'>Madagascar</option> <option value='Malawi'>Malawi</option> <option value='Malaysia'>Malaysia</option> <option value='Maldives'>Maldives</option> <option value='Mali'>Mali</option> <option value='Malta'>Malta</option> <option value='Marshall Islands'>Marshall Islands</option> <option value='Martinique'>Martinique</option> <option value='Mauritania'>Mauritania</option> <option value='Mauritius'>Mauritius</option> <option value='Mayotte'>Mayotte</option> <option value='Mexico'>Mexico</option> <option value='Micronesia, Federated States of'>Micronesia, Federated States of</option> <option value='Moldova, Republic of'>Moldova, Republic of</option> <option value='Monaco'>Monaco</option> <option value='Mongolia'>Mongolia</option> <option value='Montenegro'>Montenegro</option> <option value='Montserrat'>Montserrat</option> <option value='Morocco'>Morocco</option> <option value='Mozambique'>Mozambique</option> <option value='Myanmar'>Myanmar</option> <option value='Namibia'>Namibia</option> <option value='Nauru'>Nauru</option> <option value='Nepal'>Nepal</option> <option value='Netherlands'>Netherlands</option> <option value='Netherlands Antilles'>Netherlands Antilles</option> <option value='New Caledonia'>New Caledonia</option> <option value='New Zealand'>New Zealand</option> <option value='Nicaragua'>Nicaragua</option> <option value='Niger'>Niger</option> <option value='Nigeria'>Nigeria</option> <option value='Niue'>Niue</option> <option value='Norfolk Island'>Norfolk Island</option> <option value='Northern Mariana Islands'>Northern Mariana Islands</option> <option value='Norway'>Norway</option> <option value='Oman'>Oman</option> <option value='Pakistan'>Pakistan</option> <option value='Palau'>Palau</option> <option value='Palestinian Territory, Occupied'>Palestinian Territory, Occupied</option> <option value='Panama'>Panama</option> <option value='Papua New Guinea'>Papua New Guinea</option> <option value='Paraguay'>Paraguay</option> <option value='Peru'>Peru</option> <option value='Philippines'>Philippines</option> <option value='Pitcairn'>Pitcairn</option> <option value='Poland'>Poland</option> <option value='Portugal'>Portugal</option> <option value='Puerto Rico'>Puerto Rico</option> <option value='Qatar'>Qatar</option> <option value='Reunion'>Reunion</option> <option value='Romania'>Romania</option> <option value='Russian Federation'>Russian Federation</option> <option value='Rwanda'>Rwanda</option> <option value='Saint Helena'>Saint Helena</option> <option value='Saint Kitts and Nevis'>Saint Kitts and Nevis</option> <option value='Saint Lucia'>Saint Lucia</option> <option value='Saint Pierre and Miquelon'>Saint Pierre and Miquelon</option> <option value='Saint Vincent and The Grenadines'>Saint Vincent and The Grenadines</option> <option value='Samoa'>Samoa</option> <option value='San Marino'>San Marino</option> <option value='Sao Tome and Principe'>Sao Tome and Principe</option> <option value='Saudi Arabia'>Saudi Arabia</option> <option value='Senegal'>Senegal</option> <option value='Serbia'>Serbia</option> <option value='Seychelles'>Seychelles</option> <option value='Sierra Leone'>Sierra Leone</option> <option value='Singapore'>Singapore</option> <option value='Slovakia'>Slovakia</option> <option value='Slovenia'>Slovenia</option> <option value='Solomon Islands'>Solomon Islands</option> <option value='Somalia'>Somalia</option> <option value='South Africa'>South Africa</option> <option value='South Georgia and The South Sandwich Islands'>South Georgia and The South Sandwich Islands</option> <option value='Spain'>Spain</option> <option value='Sri Lanka'>Sri Lanka</option> <option value='Sudan'>Sudan</option> <option value='Suriname'>Suriname</option> <option value='Svalbard and Jan Mayen'>Svalbard and Jan Mayen</option> <option value='Swaziland'>Swaziland</option> <option value='Sweden'>Sweden</option> <option value='Switzerland'>Switzerland</option> <option value='Syrian Arab Republic'>Syrian Arab Republic</option> <option value='Taiwan (ROC)'>Taiwan (ROC)</option> <option value='Tajikistan'>Tajikistan</option> <option value='Tanzania, United Republic of'>Tanzania, United Republic of</option> <option value='Thailand'>Thailand</option> <option value='Timor-leste'>Timor-leste</option> <option value='Togo'>Togo</option> <option value='Tokelau'>Tokelau</option> <option value='Tonga'>Tonga</option> <option value='Trinidad and Tobago'>Trinidad and Tobago</option> <option value='Tunisia'>Tunisia</option> <option value='Turkey'>Turkey</option> <option value='Turkmenistan'>Turkmenistan</option> <option value='Turks and Caicos Islands'>Turks and Caicos Islands</option> <option value='Tuvalu'>Tuvalu</option> <option value='Uganda'>Uganda</option> <option value='Ukraine'>Ukraine</option> <option value='United Arab Emirates'>United Arab Emirates</option> <option value='United Kingdom'>United Kingdom</option> <option value='United States'>United States</option> <option value='Uruguay'>Uruguay</option> <option value='Uzbekistan'>Uzbekistan</option> <option value='Vanuatu'>Vanuatu</option> <option value='Venezuela'>Venezuela</option> <option value='Viet Nam'>Viet Nam</option> <option value='Virgin Islands, British'>Virgin Islands, British</option> <option value='Virgin Islands, U.S.'>Virgin Islands, U.S.</option> <option value='Wallis and Futuna'>Wallis and Futuna</option> <option value='Western Sahara'>Western Sahara</option> <option value='Yemen'>Yemen</option> <option value='Zambia'>Zambia</option> <option value='Zimbabwe'>Zimbabwe</option>
                  </select>
                </div>
              </div>

              <div class="beambox-row " id="beambox-birthday-picker" v-else-if="item.id == 'date_of_birth'">
                <div class="beambox-small-4 beambox-select" >
                  <select required class="" name="day" id="birthday_day" v-on:change="updateBirthday">
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                    <option value="24">24</option>
                    <option value="25">25</option>
                    <option value="26">26</option>
                    <option value="27">27</option>
                    <option value="28">28</option>
                    <option value="29">29</option>
                    <option value="30">30</option>
                    <option value="31">31</option>
                  </select>
                </div>
                <div class="beambox-small-4 beambox-select" >
                  <select required class="" name="month" id="birthday_month" v-on:change="updateBirthday">
                    <option value="1">January</option>
                    <option value="2">February</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div class="beambox-small-4 beambox-select">
                  <select required class="" name="year" id="birthday_year" v-on:change="updateBirthday">
                    <option value='2018'>2018</option>
                    <option value='2017'>2017</option>
                    <option value='2016'>2016</option>
                    <option value='2015'>2015</option>
                    <option value='2014'>2014</option>
                    <option value='2013'>2013</option>
                    <option value='2012'>2012</option>
                    <option value='2011'>2011</option>
                    <option value='2010'>2010</option>
                    <option value='2009'>2009</option>
                    <option value='2008'>2008</option>
                    <option value='2007'>2007</option>
                    <option value='2006'>2006</option>
                    <option value='2005'>2005</option>
                    <option value='2004'>2004</option>
                    <option value='2003'>2003</option>
                    <option value='2002'>2002</option>
                    <option value='2001'>2001</option>
                    <option value='2000'>2000</option>
                    <option value='1999'>1999</option>
                    <option value='1998'>1998</option>
                    <option value='1997'>1997</option>
                    <option value='1996'>1996</option>
                    <option value='1995'>1995</option>
                    <option value='1994'>1994</option>
                    <option value='1993'>1993</option>
                    <option value='1992'>1992</option>
                    <option value='1991'>1991</option>
                    <option value='1990'>1990</option>
                    <option value='1989'>1989</option>
                    <option value='1988'>1988</option>
                    <option value='1987'>1987</option>
                    <option value='1986'>1986</option>
                    <option value='1985'>1985</option>
                    <option value='1984'>1984</option>
                    <option value='1983'>1983</option>
                    <option value='1982'>1982</option>
                    <option value='1981'>1981</option>
                    <option value='1980'>1980</option>
                    <option value='1979'>1979</option>
                    <option value='1978'>1978</option>
                    <option value='1977'>1977</option>
                    <option value='1976'>1976</option>
                    <option value='1975'>1975</option>
                    <option value='1974'>1974</option>
                    <option value='1973'>1973</option>
                    <option value='1972'>1972</option>
                    <option value='1971'>1971</option>
                    <option value='1970'>1970</option>
                    <option value='1969'>1969</option>
                    <option value='1968'>1968</option>
                    <option value='1967'>1967</option>
                    <option value='1966'>1966</option>
                    <option value='1965'>1965</option>
                    <option value='1964'>1964</option>
                    <option value='1963'>1963</option>
                    <option value='1962'>1962</option>
                    <option value='1961'>1961</option>
                    <option value='1960'>1960</option>
                    <option value='1959'>1959</option>
                    <option value='1958'>1958</option>
                    <option value='1957'>1957</option>
                    <option value='1956'>1956</option>
                    <option value='1955'>1955</option>
                    <option value='1954'>1954</option>
                    <option value='1953'>1953</option>
                    <option value='1952'>1952</option>
                    <option value='1951'>1951</option>
                    <option value='1950'>1950</option>
                    <option value='1949'>1949</option>
                    <option value='1948'>1948</option>
                    <option value='1947'>1947</option>
                    <option value='1946'>1946</option>
                    <option value='1945'>1945</option>
                    <option value='1944'>1944</option>
                    <option value='1943'>1943</option>
                    <option value='1942'>1942</option>
                    <option value='1941'>1941</option>
                    <option value='1940'>1940</option>
                    <option value='1939'>1939</option>
                    <option value='1938'>1938</option>
                    <option value='1937'>1937</option>
                    <option value='1936'>1936</option>
                    <option value='1935'>1935</option>
                    <option value='1934'>1934</option>
                    <option value='1933'>1933</option>
                    <option value='1932'>1932</option>
                    <option value='1931'>1931</option>
                    <option value='1930'>1930</option>
                    <option value='1929'>1929</option>
                    <option value='1928'>1928</option>
                    <option value='1927'>1927</option>
                    <option value='1926'>1926</option>
                    <option value='1925'>1925</option>
                    <option value='1924'>1924</option>
                    <option value='1923'>1923</option>
                    <option value='1922'>1922</option>
                    <option value='1921'>1921</option>
                    <option value='1920'>1920</option>
                    <option value='1919'>1919</option>
                    <option value='1918'>1918</option>
                  </select>
                </div>
                <input required type="hidden" v-model="birthday" name="guest[birthday]" value="" id="guest_birthday">
              </div>
              <div class="beambox-row" v-else>
                <input type="text" name="" v-bind:name="item.id" value="" v-if="item.mode == '1'">
                <input type="number" name="" v-bind:name="item.id" value="" v-else-if="item.mode == '2'">
                <div class="beambox-small-12 beambox-select" v-else-if="item.mode == '3'">
                  <select required class="" name="" v-bind:name="item.id">
                    <option value=""></option>
                    <option v-for="(option) in item.options" v:bind:value="option">{{option}}</option>
                  </select>
                </div>
                <input type="date" name="" v-bind:name="item.id" value="" v-else-if="item.mode == '4'">
                <div class="beambox-small-12 beambox-select" v-else-if="item.mode == '5'">
                  <select required class="" name="" v-bind:name="item.id">
                    <option value=""></option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <button type="submit" name="button">Subscribe</button>
          <div class="beambox-disclaimer">
            <small>We respect your privacy. Unsubscribe at anytime.</small>
          </div>
          <div class="text-center">
            <a type="button" :href="baseURL" class="power-copy" style="color: white; background: rgba(0,0,0,0.4);">
              Powered by Beambox
            </a>
          </div>
        </form>
      </div>
    </div>


  </div>

</template>

<script>
  import { mapFields } from 'vuex-map-fields'

  import {required, email, maxLength, numeric, minLength} from 'vuelidate/lib/validators'

  export default {

    created(){
      var newStyle = document.createElement('style');
      newStyle.appendChild(document.createTextNode("\
      @font-face {\
          font-family: 'user_selection';\
          src: url('https://wifiuploads.s3.amazonaws.com/" + this.$store.state.font + "');\
      }\
      "));

      document.head.appendChild(newStyle);

    },
    methods: {
      submit() {

        let formData = new FormData(this.$refs.form)
        this.$store.dispatch('createGuest', formData)

      },
      close(){
        document.getElementById("beambox-embeddable-form").remove()
      },
      select(event){
        let elems = document.querySelectorAll(".beambox-form-item")
        for (var i = 0; i < elems.length; i++) {
          elems[i].classList.remove('beambox-active')
      	}
        event.currentTarget.classList.add('beambox-active')
      },
      updatePhone(){
        const phone = document.getElementById("phone_code").value + document.getElementById("phone_number_val").value
        document.getElementById("guest_phone").value = phone
      },
      updateBirthday(){
        const birthday = document.getElementById("birthday_day").value + '-' + document.getElementById("birthday_month").value + '-' + document.getElementById("birthday_year").value
        document.getElementById("guest_birthday").value = birthday
      },
    },
    computed: {
      ...mapFields([
        'full_name',
        'first_name',
        'last_name',
        'email',
        'gender',
        'country',
        'phone',
        'birthday',
        'errors',
      ]),
      cssProps(){
        return {
          '--accent_color': "#" + this.$store.state.accent_color,
          '--transparent_accent_color': "#" + this.$store.state.accent_color + "40",
          '--bg_color': "#" + this.$store.state.bg_color,
          '--font-url': (this.$store.state.font != null ? "https://wifiuploads.s3.amazonaws.com/" + this.$store.state.font : '"Source Sans Pro", sans-serif'),
        }
      },
      title_text() {
        return this.$store.state.title_text
      },
      show_image(){
        return this.$store.state.show_image
      },
      image_url(){
        return this.$store.state.image_url
      },
      form_fields(){
        return this.$store.state.form_fields
      },
      mode(){
        return this.$store.state.mode
      },
      font_url(){
        return "https://wifiuploads.s3.amazonaws.com/" + this.$store.state.font
      },
      businessname(){
        return this.$store.state.businessname
      },
      baseURL(){
        return this.$store.state.base_url
      },
      countryCode(){
        return this.$store.state.country
      },
      subProvider(){
        return this.$store.state.provider
      },
    }
  }
</script>

<style>

  #beambox-embeddable-form{
    font-family: "user_selection";
  }

  #beambox-signup-form{
    font-family: "Source Sans Pro", sans-serif !important;
  }

  #beambox-complete {
    display: none;
    text-align: center;
    font-weight: 500;
    font-size: 20px;
    position: absolute;
    top: 40%;
    width: 100%;
  }
  #beambox-complete > .checkmark {
    font-size: 2.4rem;
    font-weight: 900;
    color: var(--accent_color);
    background: var(--transparent_accent_color);
    width: 5rem;
    height: 5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: auto;
  }
  #beambox-complete > .checkmark > svg {
    height: 2.4rem;
    fill: var(--accent_color)
  }

  .beambox-disclaimer{
    color: #556670;
    text-align: center;
    padding: 1rem 0 2.5rem;
  }

  .text-center {
    text-align: center !important;
  }

  .power-copy {
    font-size: .7rem;
    padding: 0.5rem;
    display: inline-block;
    text-align: center;
    margin-bottom: 1rem;
    margin-top: 0;
    border-radius: 5px;
  }

  .beambox-mask{
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(16,16,16,0.65);
  }

  .beambox-main-cont{
    background: #fff;
    margin-top: 4rem;
    margin-bottom: 4rem;
    margin-left: auto;
    margin-right: auto;
    border-radius: 3px;
    flex: 0 0 66.66667%;
    max-width: 600px;
    position: relative;
  }

  .beambox-main-cont-inline{
    background: #fff;
    border-radius: 3px;
    flex: 0 0 66.66667%;
    .form-item.active input {
      border-bottom: 1px solid var(--accent_color) !important;
    }
  }

  .beambox-img-cont{
    padding: 1.5rem;
    text-align: center !important;
    background: var(--bg_color);
    border-radius: 3px 3px 0 0;
    position: relative;
  }

  .beambox-img-cont-inline{
    padding: 1.5rem;
    text-align: center !important;

    border-radius: 3px 3px 0 0;
    position: relative;
  }

  .beambox-img-cont > img {
    max-height: 128px;
  }

  .beambox-main-description{
    text-align: center;
    font-weight: 500;
    font-size: 22.5px;
    padding: 1.75rem;
  }

  .beambox-main-description > p {
    color: black !important;
  }

  .beambox-form-item > label {
    font-family: 'Sorce Sans Pro', sans-serif !important;
    display: block;
    position: absolute;
    top: 0.1rem;
    left: 1.75rem;
    font-size: 0.8rem;
    z-index: 8;
    color: #adadad;
    padding-top: 0.5rem;
  }

  .beambox-form-item > input[type="text"], .beambox-text > input[type="text"] {
    position: relative;
    top: 0;
    z-index: 1;
    height: 4rem !important;
    width: 100%;
    border: 0;
    font-size: 1rem;
    font-weight: 500;
    padding: 1.4rem 0 0 0.25rem!important;
    background-color: transparent !important;
    border:none!important;
    border-bottom: 1px solid #ebeaea!important;
    border-radius: 0!important;
    display: initial !important;
    margin: initial !important;
    box-sizing: border-box;
  }
  .beambox-form-item > input[type="email"]{
    position: relative;
    top: 0;
    z-index: 1;
    height: 4rem !important;
    width: 100%;
    border: 0;
    font-size: 1rem;
    font-weight: 500;
    padding: 1.4rem 0 0 0.25rem!important;
    background-color: transparent !important;
    border:none!important;
    border-bottom: 1px solid #ebeaea!important;
    border-radius: 0!important;
    display: initial !important;
    box-sizing: border-box;
  }
  .beambox-form-item > .beambox-row > input[type="text"], .beambox-form-item > .beambox-row > input[type="number"], .beambox-form-item > .beambox-row > input[type="date"] {
    position: relative;
    top: 0;
    z-index: 1;
    height: 4rem !important;
    width: 100%;
    border: 0;
    font-size: 1rem;
    font-weight: 500;
    padding: 1.4rem 0 0 0.25rem!important;
    background-color: transparent !important;
    border:none!important;
    border-bottom: 1px solid #ebeaea!important;
    border-radius: 0!important;
    display: initial !important;
    box-sizing: border-box;
  }
  .beambox-form-item > label > input[type="checkbox"]{
    position: relative;
    top: 2px;
    left: -1px;
    display: initial !important;
  }
  .beambox-form-item > input:focus, .beambox-form-item > input:focus-visible, .beambox-form-item > label > input:focus, .beambox-text>input[type=text]:focus, .beambox-text>input[type=text]:focus-visible {
    outline: none!important;
  }
  .beambox-error-message{
    color: #fc6565 !important;
    margin: 5px 0 5px 1.9rem;
    line-height: 1.8rem;
  }
  .beambox-error input {
    border-color: #fc6565 !important;
    color: #fc6565 !important;
  }

  .beambox-main-cont > form > div > .beambox-form-item.beambox-active{
    border-left: 3px solid var(--accent_color);
  }

  .beambox-main-cont-inline > form > div > .beambox-form-item.beambox-active > input{
    border-bottom: 1px solid var(--accent_color)!important;
  }
  .beambox-main-cont-inline > form > div > .beambox-form-item.beambox-active > div > div > select{
    border-bottom: 1px solid var(--accent_color)!important;
  }
  .beambox-main-cont-inline > form > div > .beambox-form-item.beambox-active > div > div > input{
    border-bottom: 1px solid var(--accent_color)!important;
  }



  .beambox-main-cont-inline > form > div > .beambox-form-item.error > input{
    border-bottom: 1px solid red !important;
  }
  .beambox-main-cont-inline > form > div > .beambox-form-item.error > div > div > select{
    border-bottom: 1px solid red !important;
  }
  .beambox-main-cont-inline > form > div > .beambox-form-item.error > div > div > input{
    border-bottom: 1px solid red !important;
  }

  .beambox-select > select{
    z-index: 1;
    width: 100%;
    background: none!important;
    border: none!important;
    border-bottom: 1px solid #ebeaea!important;
    border-radius: 0;
    font-size: 1rem;
    display: initial !important;
    height: 4rem !important;
    padding-top: 1.5rem !important;
    appearance: auto !important;
    -webkit-appearance: auto !important;
    margin: 0 !important;
  }
  .beambox-error > div > div > select {
    border-color: #fc6565 !important;
    color: #fc6565 !important;
  }

  .beambox-select > select:focus{
    outline: none!important;
  }

  .beambox-form-item{
    border-left: 3px solid #fff;
    border-right: 3px solid #fff;
    position: relative;
    height: 4rem;
    max-width: 100%;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
    display: block;
    margin-bottom: 10px;
  }



  #beambox-signup-form > button[type=submit]{
    background-color: var(--accent_color);
    border: 1px solid var(--accent_color);
    color: #fff;
    width: calc(100% - 3.5rem);
    margin: 1.75rem 1.75rem 0 1.75rem;
    padding: 0.75rem;
    border-radius: 3px;
    font-size: 14px;
  }

  #beambox-signup-form > button[type=submit]:hover {
    cursor: pointer;
  }

  #beambox-signup-form > button[type=submit]:focus {
    outline: none!important;
  }

  #beambox-close-form{
    position: absolute;
    top: 0;
    right: 0;
    padding: 15px;
    background: rgba(0,0,0,0);
    border: none;
    color: #adadad;
    z-index: 1;
  }
  #beambox-close-form:hover {
    cursor: pointer;
  }
  #beambox-close-form:focus {
    outline: none;
  }


/* line 826, app/assets/stylesheets/template.scss */
.beambox-select {
  width: 100%;
}

/* line 829, app/assets/stylesheets/template.scss */
.beambox-row {
  margin-right: auto;
  margin-left: auto;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
}

/* line 837, app/assets/stylesheets/template.scss */
.beambox-row .beambox-row {
  margin-right: -0.9375rem;
  margin-left: -0.9375rem;
}

@media print, screen and (min-width: 40em) {
  /* line 841, app/assets/stylesheets/template.scss */
  .beambox-row .beambox-row {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}

@media print, screen and (min-width: 64em) {
  /* line 845, app/assets/stylesheets/template.scss */
  .beambox-row .beambox-row {
    margin-right: -0.9375rem;
    margin-left: -0.9375rem;
  }
}

/* line 848, app/assets/stylesheets/template.scss */
.beambox-row .beambox-row.collapse {
  margin-right: 0;
  margin-left: 0;
}

/* line 851, app/assets/stylesheets/template.scss */
.beambox-row.expanded {
  max-width: none;
}

/* line 853, app/assets/stylesheets/template.scss */
.beambox-row.expanded .beambox-row {
  margin-right: auto;
  margin-left: auto;
}

/* line 856, app/assets/stylesheets/template.scss */
.beambox-row:not(.expanded) .beambox-row {
  max-width: none;
}

/* line 858, app/assets/stylesheets/template.scss */
.beambox-row.collapse > .beambox-column, .beambox-row.collapse > .beambox-columns {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

/* line 861, app/assets/stylesheets/template.scss */
.beambox-row.is-collapse-child,
.beambox-row.collapse > .beambox-column > .beambox-row,
.beambox-row.collapse > .beambox-columns > .beambox-row {
  margin-right: 0;
  margin-left: 0;
}

/* line 867, app/assets/stylesheets/template.scss */
.beambox-column, .beambox-columns {
  -ms-flex: 1 1 0px;
  flex: 1 1 0px;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
  min-width: 0;
}

/* line 874, app/assets/stylesheets/template.scss */
.beambox-column.beambox-row.beambox-row, .beambox-row.beambox-row.beambox-columns {
  float: none;
  display: block;
}

/* line 878, app/assets/stylesheets/template.scss */
.beambox-row .beambox-column.beambox-row.beambox-row, .beambox-row .beambox-row.beambox-row.beambox-columns {
  margin-right: 0;
  margin-left: 0;
  padding-right: 0;
  padding-left: 0;
}

/* line 884, app/assets/stylesheets/template.scss */
.beambox-small-1 {
  -ms-flex: 0 0 8.33333%;
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
}

/* line 889, app/assets/stylesheets/template.scss */
.beambox-small-offset-0 {
  margin-left: 0%;
}

/* line 892, app/assets/stylesheets/template.scss */
.beambox-small-2 {
  -ms-flex: 0 0 16.66667%;
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

/* line 897, app/assets/stylesheets/template.scss */
.beambox-small-offset-1 {
  margin-left: 8.33333%;
}

/* line 900, app/assets/stylesheets/template.scss */
.beambox-small-3 {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

/* line 905, app/assets/stylesheets/template.scss */
.beambox-small-offset-2 {
  margin-left: 16.66667%;
}

/* line 908, app/assets/stylesheets/template.scss */
.beambox-small-4 {
  -ms-flex: 0 0 33.33333%;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

/* line 913, app/assets/stylesheets/template.scss */
.beambox-small-offset-3 {
  margin-left: 25%;
}

/* line 916, app/assets/stylesheets/template.scss */
.beambox-small-5 {
  -ms-flex: 0 0 41.66667%;
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
}

/* line 921, app/assets/stylesheets/template.scss */
.beambox-small-offset-4 {
  margin-left: 33.33333%;
}

/* line 924, app/assets/stylesheets/template.scss */
.beambox-small-6 {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

/* line 929, app/assets/stylesheets/template.scss */
.beambox-small-offset-5 {
  margin-left: 41.66667%;
}

/* line 932, app/assets/stylesheets/template.scss */
.beambox-small-7 {
  -ms-flex: 0 0 58.33333%;
  flex: 0 0 58.33333%;
  max-width: 58.33333%;
}

/* line 937, app/assets/stylesheets/template.scss */
.beambox-small-offset-6 {
  margin-left: 50%;
}

/* line 940, app/assets/stylesheets/template.scss */
.beambox-small-8 {
  -ms-flex: 0 0 66.66667%;
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}

/* line 945, app/assets/stylesheets/template.scss */
.beambox-small-offset-7 {
  margin-left: 58.33333%;
}

/* line 948, app/assets/stylesheets/template.scss */
.beambox-small-9 {
  -ms-flex: 0 0 75%;
  flex: 0 0 75%;
  max-width: 75%;
}

/* line 953, app/assets/stylesheets/template.scss */
.beambox-small-offset-8 {
  margin-left: 66.66667%;
}

/* line 956, app/assets/stylesheets/template.scss */
.beambox-small-10 {
  -ms-flex: 0 0 83.33333%;
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

/* line 961, app/assets/stylesheets/template.scss */
.beambox-small-offset-9 {
  margin-left: 75%;
}

/* line 964, app/assets/stylesheets/template.scss */
.beambox-small-11 {
  -ms-flex: 0 0 91.66667%;
  flex: 0 0 91.66667%;
  max-width: 91.66667%;
}

/* line 969, app/assets/stylesheets/template.scss */
.beambox-small-offset-10 {
  margin-left: 83.33333%;
}

/* line 972, app/assets/stylesheets/template.scss */
.beambox-small-12 {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

/* line 977, app/assets/stylesheets/template.scss */
.beambox-small-offset-11 {
  margin-left: 91.66667%;
}

/* line 980, app/assets/stylesheets/template.scss */
.beambox-small-up-1 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 983, app/assets/stylesheets/template.scss */
.beambox-small-up-1 > .beambox-column, .beambox-small-up-1 > .beambox-columns {
  -ms-flex: 0 0 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

/* line 988, app/assets/stylesheets/template.scss */
.beambox-small-up-2 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 991, app/assets/stylesheets/template.scss */
.beambox-small-up-2 > .beambox-column, .beambox-small-up-2 > .beambox-columns {
  -ms-flex: 0 0 50%;
  flex: 0 0 50%;
  max-width: 50%;
}

/* line 996, app/assets/stylesheets/template.scss */
.beambox-small-up-3 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 999, app/assets/stylesheets/template.scss */
.beambox-small-up-3 > .beambox-column, .beambox-small-up-3 > .beambox-columns {
  -ms-flex: 0 0 33.33333%;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

/* line 1004, app/assets/stylesheets/template.scss */
.beambox-small-up-4 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 1007, app/assets/stylesheets/template.scss */
.beambox-small-up-4 > .beambox-column, .beambox-small-up-4 > .beambox-columns {
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}

/* line 1012, app/assets/stylesheets/template.scss */
.beambox-small-up-5 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 1015, app/assets/stylesheets/template.scss */
.beambox-small-up-5 > .beambox-column, .beambox-small-up-5 > .beambox-columns {
  -ms-flex: 0 0 20%;
  flex: 0 0 20%;
  max-width: 20%;
}

/* line 1020, app/assets/stylesheets/template.scss */
.beambox-small-up-6 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 1023, app/assets/stylesheets/template.scss */
.beambox-small-up-6 > .beambox-column, .beambox-small-up-6 > .beambox-columns {
  -ms-flex: 0 0 16.66667%;
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

/* line 1028, app/assets/stylesheets/template.scss */
.beambox-small-up-7 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 1031, app/assets/stylesheets/template.scss */
.beambox-small-up-7 > .beambox-column, .beambox-small-up-7 > .beambox-columns {
  -ms-flex: 0 0 14.28571%;
  flex: 0 0 14.28571%;
  max-width: 14.28571%;
}

/* line 1036, app/assets/stylesheets/template.scss */
.beambox-small-up-8 {
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}

/* line 1039, app/assets/stylesheets/template.scss */
.beambox-small-up-8 > .beambox-column, .beambox-small-up-8 > .beambox-columns {
  -ms-flex: 0 0 12.5%;
  flex: 0 0 12.5%;
  max-width: 12.5%;
}

/* line 1044, app/assets/stylesheets/template.scss */
.beambox-small-collapse > .beambox-column, .beambox-small-collapse > .beambox-columns {
  padding-right: 0;
  padding-left: 0;
}

/* line 1048, app/assets/stylesheets/template.scss */
.beambox-small-uncollapse > .beambox-column, .beambox-small-uncollapse > .beambox-columns {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

</style>
